import React, { Component } from 'react';
import './ArchiveList.css';
import * as api from '../../../api';

class ArchiveList extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const items = api.getVideoData().map((item) => {
      const itemData = item[1];
      const itemInfo = api.getInfo(item[0]);

      return (
        <div className="archive-item" key={item[0]}>
          <div className="title-main">
            {itemData.title}
          </div>
          {itemInfo.title && itemInfo.title.length > 0 &&
          <div className="title-show">
            {itemInfo.title}
          </div>
          }
          {itemInfo.partTitle && itemInfo.partTitle.length > 0 &&
          <div className="title-part">
            {itemInfo.partTitle}
          </div>
          }
          {itemInfo.description && itemInfo.description.length > 0 &&
          <div>
            {itemInfo.description}
          </div>
          }
          {itemData.director && itemData.director.length > 0 &&
          <div>
            <h4>Režie</h4>
            {itemData.director}
          </div>
          }
          {itemInfo.premiere && itemInfo.premiere.length > 0 &&
          <div>
            <h4>Premiéra</h4>
            {itemInfo.premiere}
          </div>
          }
          {itemInfo.link && itemInfo.link.length > 0 &&
          <a
            className="show-link"
            href={itemInfo.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            Stránka pořadu
          </a>
          }
        </div>
      );
    });

    return (
      <div id="archive-list">
        <div className="head">
          Seznam použitých zdrojů z archivu ČT
        </div>
        <div>
          {items}
        </div>
      </div>
    );
  }
}

export default ArchiveList;



// WEBPACK FOOTER //
// ./src/components/App/ArchiveList/ArchiveList.js